module.exports = __webpack_public_path__ + "images/grey-chevron-f574872a.svg";